import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useContext } from 'react'

import { Pagination, Spinner } from '@/components/ui'
import InterventionItem from '@/components/shared/intervention/InterventionItem'
import BienContext from '@/features/biens/BienContext'
import { fetchInterventions } from '@/features/interventions/interventionsSlice'

const Interventions = () => {
  const dispatch = useDispatch()
  const { bien } = useContext(BienContext)
  const interventions = useSelector((state) => state.interventions.items)
  const pagination = useSelector((state) => state.interventions.pagination)
  const loading = useSelector((state) => state.interventions.loadingStatus.fetchList)

  useEffect(() => {
    if (bien?.id) {
      dispatch(fetchInterventions({ bien_id: bien.id }))
    }
  }, [bien?.id])

  const handlePageChange = (page) => {
    dispatch(fetchInterventions({ bien_id: bien.id, page }))
  }

  return (
    <div className='mb-4'>
      <h3 className="text-md font-semibold mb-2">
        Historique des interventions de ce logement
      </h3>
      <div className="bg-primary-100 p-4 rounded-none w-full h-full">
        {loading && <Spinner />}
        {!loading && (
          <>
            <div className="flex flex-wrap gap-4">
              {interventions.length === 0 ? (
                <div className="text-center py-4 text-gray-600 italic w-full">
                  Aucune intervention durant votre bail
                </div>
              ) : (
                interventions.map((item, index) => (
                  <InterventionItem key={`${item.id}-${index}`} item={item} />
                ))
              )}
            </div>
            {pagination.totalPages > 1 && (
              <Pagination
                currentPage={pagination.currentPage}
                totalPages={pagination.totalPages}
                onPageChange={handlePageChange}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default Interventions
